export const trackSignUp = (source) => {
  window.gtag('event', 'sign_up_link_click', {
    source,
  });
};
